export const loaderStyles = {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

export const storeBadgeStyles = (isEccoStore: boolean) => ({
    bg: isEccoStore ? "black" : "gray.500",
    color: "white",
    py: 1,
    px: 2,
    mt: 4,
    w: "fit-content",
    fontWeight: "bold",
});

export const virtualListStyles = {
    verticalScrollBar: {
        background: "#D2D2D2",
        width: 0,
    },
    verticalScrollBarThumb: {
        background: "black",
        borderRadius: 0,
    },
};

export const accordion = {
    container: {
        bg: "gray.100",
        mr: [0, 3],
    },
    item: {
        bg: "gray.100",
        mb: "0.2",
        borderBottomStyle: "solid",
        borderBottomColor: "white",
    },
    button: {
        width: "100%",
        px: [3, 6],
        py: [4, 6],
        pb: [4],
        textAlign: "left",
        alignItems: "flex-start",
        borderRadius: "inherit",
        flexDirection: "column",
        "&[aria-expanded=true]": {
            px: [3, 6],
            py: [4, 6],
            paddingBottom: [0, 0],
            bg: "transparent",
        },
    },
    panel: {
        px: [3, 6],
        pb: [4, 4],
    },
};
